import z from 'zod';
import { createNewTypeStringSchema } from '@shared/schemas';
import { Year } from '@shared/modules/dates';

export const reportSchema = z.object({
  year: createNewTypeStringSchema<Year>(),
});
